import '../screens/ServiceRequestsDiscover/ServiceRequestsDiscover.scss';

import { PiPlus } from 'react-icons/pi';

import { useAppNavigate } from '../../../shared/hooks';
import { ROUTES } from '../../../types/routes';

const TQCreateNewRequestButton = () => {
  const navigate = useAppNavigate();
  return (
    <button
      type="button"
      className="tq-create-new-request"
      onClick={() => {
        navigate(
          ROUTES.TQ_CONNECT_SERVICE_REQUESTS_CREATE,
          {},
          { reset: true },
        );
      }}>
      <PiPlus size={16} aria-hidden />
      {''} Create new request
    </button>
  );
};

export default TQCreateNewRequestButton;
